import {
  STANDARD_SHIPPING_METHOD,
  ADVANCE_SHIPPING_METHOD,
  EXPEDITE_SHIPPING_METHOD,
} from 'utils/constants';

// Options to be used on Dropdown

export const shippingMethods = [
  { id: STANDARD_SHIPPING_METHOD, text: 'Standard' },
  { id: ADVANCE_SHIPPING_METHOD, text: 'Advance Exchange' },
  { id: EXPEDITE_SHIPPING_METHOD, text: 'Expedite Exchange' },
];
